<div id="sidenav-overlay" (click)="closeNav()">
</div>
<nav class="navbar navbar-expand-lg navbar-light navs_common">
  <div id="mySidenav" class="sidenav">
    <div class="row details-title">
      <div class="col-2 pic-icon">
        <label>{{getShortName(name)}}</label>
      </div>
      <div class="col-8 user-details" routerLink="/home" (click)="closeNav()">
        <p>{{name}}</p>
        <p *ngIf="mobile !== null && mobile !== '' || mobile !== 'undefined'">Mob: +91 {{mobile}}</p>
      </div>
      <!-- <div class="col-2 text-center no-padding" routerLink="/settings"> -->
        <div class="col-2 text-center no-padding" routerLink="/edit-profile" title="Edit Profile">      
          <img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/Settings.svg"
            class="setting-icon" width="80%">
        </div>
    </div>
    <ul class="product-list">
      <!-- <li (click)="checkLoggedin();closeNav()" *ngIf="isDisplayAttendance">Attendance</li> -->
      
      <li id="accordion">
        <div>
          <div class="card" *ngIf="isDisplayAttendance">
            <div class="card-header border-btm-0" (click)="checkLoggedin();closeNav()">
              <span class="attendance" >
                Attendance
              </span>
            </div>
          </div>

          <ng-container *ngIf="showSecurenowFacilities">
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#buyCollapse1">
                Buy
              </a>
            </div>
            <div id="buyCollapse1" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <li routerLink="/family-health-insurance"><img
                    src="/assets/icons/HealthInsurance.svg">Health
                  Insurance</li>
                <li (click)="createProspectForMotor()"><img
                    src="/assets/icons/MotorInsurance.svg">Motor
                  Insurance</li>
                <li routerLink="/personal-accident"><img
                    src="/assets/icons/PersonalAccident.svg">Personal
                  Accident</li>
                <li routerLink="/doctor-professional-indemnity"><img
                    src="/assets/icons/DoctorsIndemnity.svg">Doctor
                  Professional Indemnity</li>
                <li routerLink="/term-life-info"><img
                    src="/assets/icons/TermLife.svg"> Term Life
                </li>
                <li (click)="createProspectForHospitalCash()"><img
                  src="/assets/icons/HospitalCash.svg"> Hospital Cash
                </li>
                <li routerLink="/senior-citizen-insurance"><img
                  src="/assets/icons/SeniorCitizenInsurance.svg"> Senior Citizen Insurance
                </li>

                <!-- <li (click)="healthAssureUpdate()"><img
                    src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/nav-bar/doctor-icon.svg">Health-Assure
                </li> -->
              </div>
            </div>
          </div>
        </ng-container>
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
                View
              </a>
            </div>
            <div id="collapseTwo" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <li *ngIf="showPolicies" routerLink="/yourPolicies" (click)="closeNav()"><img
                    src="/assets/icons/YourPolicies.svg">Your
                  Policies</li>
                <li routerLink="/e-cards" (click)="closeNav()"><img
                    src="/assets/icons/HealthECards.svg">Group Policy E-cards
                </li>
                <li routerLink="/hospitalLocator"><img
                    src="/assets/icons/HospitalLocator.svg">Hospital
                  Locator</li>
                <li routerLink="/add-policy" (click)="closeNav()"><img
                    src="/assets/icons/AddPolicies.svg">Add
                  Policy</li>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseThree">
                Claim
              </a>
            </div>
            <div id="collapseThree" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <li routerLink="/register"><img
                    src="/assets/icons/Register.svg">Register
                </li>
                <li routerLink="/submit"><img
                    src="/assets/icons/Submit.svg">Submit
                </li>
                <li routerLink="/status"><img
                    src="/assets/icons/CheckStatus.svg">Check
                  Status</li>
                  <!-- <li (click)="checKClaimsFAQ()"><img class="claimsFAQ"
                    src="/assets/icons/claims_FAQ.png">Claims FAQ
                  </li> -->
              </div>
            </div>
          </div>

          <ng-container *ngIf="showSecurenowFacilities">
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseFive">
                Treatment
              </a>
            </div>
            <div id="collapseFive" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <li routerLink="/poly-clinic"><img
                  src="/assets/icons/PolyClinic.svg">Poly Clinic</li>
                <!-- <li (click)="redirectToMfineSidebar()">
                  <img height="33" width="33" src="/assets/images/discounted_specialist.svg">Discounted Specialist Consultation
                </li> -->
                <li *ngIf="showMFineFGPC" (click)="redirectToFreeGeneralConsultaion('SECURE-NOW-GP')">
                  <img height="33" width="33" src="/assets/images/free_general_physician_consultation.svg">General Physician Consultation
                </li>
                <li *ngIf="showMFineFreeSpecialist" (click)="getVisitTeleConsultation('SECURE-NOW-SP')">
                  <img height="33" width="33" src="/assets/images/free-specialist.svg">Specialist Consultation
                </li>
                <li *ngIf="showPsychiatrist" (click)="getVisitPsychiatrist('SECURE-NOW-PY')">
                  <span class="icon-badge"><img src="/assets/images/Super_Specialist_Consultation.svg"></span>Psychiatrist Consultation
                </li>
                <!-- <li (click)="redirectToMedPay()">
                  <img height="33" width="33" style="border-radius: 5px;" src="/assets/images/Discounted_Pharmacy_medpay.svg">Discounted Pharmacy
                </li> -->
                <li routerLink="/healthPackage"><img
                      src="/assets/icons/HealthCheckup.svg">Health Checkup</li>
                <!-- <li routerLink="/surgical-care"><img
                  src="/assets/icons/SurgicalCare.svg">Surgical Care</li> -->

                  <!-- Hide Cosmetic Surgery Icon asked by Saurabh -->
                <!-- <li routerLink="/cosmetic-surgery"><img
                    src="/assets/icons/CosmeticSurgery.svg">Cosmetic Surgery</li> -->
                 <li (click)="corporateHealthCheckup('SECURE-NOW-AHC')" *ngIf="isCorporateHealthCheckupRestricted">
                  <img height="33" width="33" src="/assets/images/corporate-health-checkup.svg">Corporate Health Checkup
                </li> 
                <li routerLink="/hra-calculator">
                  <span class="icon-badge"><img src="/assets/images/hra-calculator.png"></span>Health Risk Assessment
                </li>
                <li [routerLink]="['/poly-clinic']" [queryParams]="{ service: 'mentalHealth' }">
                  <span class="icon-badge"><img src="/assets/images/mental-health.svg"></span>Mental Health
                </li>
              </div>
            </div>
          </div>
        </ng-container>
          <div class="card">
            <div class="card-header border-btm-0">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseFour">
                Refer
              </a>
            </div>
            <div id="collapseFour" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <li routerLink="/refer"><img
                    src="/assets/icons/ReferandEarn_Product.svg">Product
                </li>
                <!-- <li routerLink="/articles"><img
                    src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/nav-bar/article-icon.svg">Article
                </li> -->
              </div>
            </div>
          </div>

          <div class="card" *ngIf="roleData.pamUserRole === 'ROLE_RELATIONSHIP_MANAGER'">
            <div class="card-header border-btm-0" routerLink="/policy-booking">
              <span class="agentApp" >
                Agent App
              </span>
            </div>
          </div>

          <!-- <div class="card" *ngIf="roleData.pamUserRole === 'ROLE_RELATIONSHIP_MANAGER'">
            <div class="card-header border-btm-0" routerLink="/policy-booking">
              <a class="agentApp">
                Agent App
              </a>
            </div>
          </div> -->
            <!-- <div id="collapsePartner" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <li routerLink="/policy-booking"><img src=""/>Policy Booking</li>
                <li routerLink="/mis"><img src=""/>MIS</li>
              </div>
            </div> -->
          
        </div>
      </li>
        <!-- <li routerLink="/refer" (click)="checkLoggedin()">Refer</li> -->
        <!-- <li *ngIf="checkLaunchFlag" routerLink="/launch-offer" (click)="checkLoggedin()"><span class="special">
            Launch Offer</span></li> -->
      <li routerLink="/profile">Profile</li>
      <li *ngIf="showSecurenowFacilities" routerLink="/profile/add-family">Add Family</li>
      <li routerLink="/wallet">Wallet</li>
      <li routerLink="/requested-quotes">Retrieve Your Quotes</li>
      <div class="notification-row">
        <span class="notification-text">Notifications</span>
      
        <label class="switch">
          <input type="checkbox" [checked]="isNotificationEnabled === 'true'" (change)="toggleNotification($event)" />
          <span class="slider"></span>
        </label>
      </div>
      <li routerLink="/aboutUs">About Us</li>
      <!-- <li (click)="logout()">Logout</li> -->
      <div class="card2" >
        <div class="card-header border-btm-0" (click)="logout()">
          <span class="logout" >
            Logout
          </span>
        </div>
      </div>
    </ul>
    <div class="nav-logo" routerLink="/home">
      <img (click)="closeNav()"
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow_logo.svg">
    </div>
  </div>

  <div class="header-main insurs3">
    <div class="row">
      <div class="col-1" *ngIf="navIcon == 'back'" id="main">
        <span class="back-icon" (click)="backClicked()"><img class="img-responsive"
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/back.svg"></span>
      </div>
      <div class="col-2 text-left no-padding" *ngIf="navIcon == 'menu'" id="main">
        <span class="menu-icon" (click)="openNav()"><img class="img-responsive"
            src="assets/images/hanburger.svg"></span>
      </div>
      <div class="col-10" *ngIf="navTitle && navTitle !== 'Home'">
        <span class="headerHeading">{{navTitle}}</span>
      </div>
      <div class="col-10 text-left secure_insu" *ngIf="navTitle === 'Home'">
        <div class="app-header secure_insu1">
          <div class="app-title"> SecureNow Insurance
          </div>
          <!--<div class=" text-center p-0" routerLink="/notifications-new"><img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/whitebell.svg"
              class="img img-fluid" alt=""><span class="pending-notifications" *ngIf="notificationCount"></span></div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex" style="gap:1rem;">
    <div class="notification-wrapper text-center p-0 pt-1">
  <a routerLink="/new-notifications" class="bell-container">
    
    <img
      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/whitebell.svg"
      class="img img-fluid"
      alt=""
      style="height: 35px; width: 35px;"
    />

    <span *ngIf="unreadNotificationcount > 0" class="notification-badge">
      {{ unreadNotificationcount }}
    </span>

  </a>
</div>

  <div class="dropdown earn_points1">

    <a class="" routerLink="/wallet" href="#">
      <img src="assets/images/Wallet.svg">
      
      <!-- <i class="fas fa-wallet"></i> -->
      <!-- <span class="earn_pints">{{balanceValue}}</span> -->
      <!-- <span class="earn_pints">{{referralData.Balance}}</span> -->
    </a>
    <a class="" routerLink="/wallet" href="#">
    <span class="earn_pint">Wallet</span>
  </a>
    
    <!-- <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      Wallet Points
    </button>
    <div class="dropdown-menu earn_points" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" routerLink="/wallet" href="#">Total Earn Wallet Points <span class="earn_pints">₹{{referralData.Balance}}</span></a>
      <a routerLink="/refer" class="dropdown-item refer_prod">Refer Product</a>
      <a class="dropdown-item" href="#">Referral Product</a>
    </div> -->
  </div>

  </div>
</nav>

<div class="modal fade" id="localtionEnableModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <div class="form-group text-center">
          <p>{{locationErrorMessage}}</p>
        </div>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer block text-center">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
      </div>

    </div>
  </div>
</div>
